import React from 'react';
export const Checklist = () => {
  return <div className="w-full bg-white py-12" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-16">
        <h2 className="text-2xl font-bold text-green-900 text-center mb-6" data-id="element-17">
          Is Your Dog Showing Signs of "Modern Diet Deficiency"?
        </h2>
        <p className="text-center text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-18">
          Beyond bad breath, these symptoms all stem from the same root cause:
        </p>
        <div className="bg-green-50 rounded-lg p-6 md:p-8 max-w-3xl mx-auto mb-12" data-id="element-19">
          <h3 className="font-bold text-green-900 mb-4" data-id="element-20">
            The Modern Diet Deficiency Checklist:
          </h3>
          <div className="grid md:grid-cols-2 gap-3" data-id="element-21">
            <div className="flex items-center" data-id="element-22">
              <input type="checkbox" className="h-5 w-5 mr-3 accent-amber-600" data-id="element-23" />
              <span data-id="element-24">Chronic bad breath despite dental care</span>
            </div>
            <div className="flex items-center" data-id="element-25">
              <input type="checkbox" className="h-5 w-5 mr-3 accent-amber-600" data-id="element-26" />
              <span data-id="element-27">Excessive gas or digestive issues</span>
            </div>
            <div className="flex items-center" data-id="element-28">
              <input type="checkbox" className="h-5 w-5 mr-3 accent-amber-600" data-id="element-29" />
              <span data-id="element-30">Low energy or "aging" too fast</span>
            </div>
            <div className="flex items-center" data-id="element-31">
              <input type="checkbox" className="h-5 w-5 mr-3 accent-amber-600" data-id="element-32" />
              <span data-id="element-33">Itchy skin or dull coat</span>
            </div>
            <div className="flex items-center" data-id="element-34">
              <input type="checkbox" className="h-5 w-5 mr-3 accent-amber-600" data-id="element-35" />
              <span data-id="element-36">Stiff joints or slow movement</span>
            </div>
            <div className="flex items-center" data-id="element-37">
              <input type="checkbox" className="h-5 w-5 mr-3 accent-amber-600" data-id="element-38" />
              <span data-id="element-39">Frequent ear or skin infections</span>
            </div>
          </div>
          <p className="text-sm text-gray-600 mt-6" data-id="element-40">
            If you checked even ONE box, your dog's processed diet has likely
            depleted their ancestral nutrients and disrupted their gut balance.
          </p>
        </div>
        <div className="text-center" data-id="element-41">
          <button className="bg-amber-600 text-white font-semibold py-3 px-8 rounded-full hover:bg-amber-500 transition" onClick={() => {
          window.open('https://snoutyco.com/products/the-daily-foundation-chew', '_blank');
        }} data-id="element-42">
            Restore Your Dog's Gut Health
          </button>
        </div>
      </div>
    </div>;
};